<template>
	<div>
		<navbar :title="title" />
		<van-grid :column-num="3">
			<van-grid-item v-for="item in list" :key="item.id" :to="item.router">
				<svg class="iconfont" aria-hidden="true">
					<use :xlink:href="item.icon" />
				</svg>
				<div class="iconfont-text">{{item.text}}</div>
			</van-grid-item>
		</van-grid>

		<van-tabbar v-model="activeName">
			<van-tabbar-item name="add" icon="add-o" to="/review">新的申请</van-tabbar-item>
			<van-tabbar-item name="approval" icon="clock-o" to="/review/approval">我的审批</van-tabbar-item>
			<van-tabbar-item name="list" icon="upgrade" to="/review/list">提交记录</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";

export default {
	name: "review",
	components: {
		navbar
	},
	data() {
		return {
			activeName: "add",
			title: "审批流程",
			list: [
				{
					id: 1,
					text: "请假",
					icon: "#icon-qingjia",
					router: "/review/add?type=0"
				},
				{
					id: 2,
					text: "费用",
					icon: "#icon-feiyongdanju",
					router: "/review/add?type=1"
				},
				{
					id: 3,
					text: "出差",
					icon: "#icon-waichu",
					router: "/review/add?type=2"
				},
				{
					id: 4,
					text: "报备",
					icon: "#icon-huodongbaobei",
					router: "/review/add?type=3"
				},
				{
					id: 5,
					text: "保证金",
					icon: "#icon-qianbaoanquan",
					router: "/review/add?type=4"
				},
				{
					id: 6,
					text: "采购支付",
					icon: "#icon-caigou",
					router: "/review/add?type=5"
				},
				{
					id: 7,
					text: "用章",
					icon: "#icon-shenpi",
					router: "/review/add?type=6"
				},
				{
					id: 8,
					text: "报销",
					icon: "#icon-baoxiao",
					router: "/review/add?type=7"
				},
				{
					id: 9,
					text: "投标",
					icon: "#icon-qiandao1",
					router: "/review/add?type=8"
				}
			]
		};
	}
};
</script>

<style>
.add-button {
	position: fixed;
	bottom: 50px;
	right: 50px;
	width: 46px;
	height: 46px;
	display: flex;
	align-items: center;
	justify-content: center;
}
</style>
